import InnerPageTech from './innerPageTech'
import TemplateMain from '../templateMain'
import { useParams } from 'react-router-dom'
import { SLIDESHOWS, TECH_DISPLAY } from '../../types'

export default function PageTech() {
  const { display, value } = useParams()
  return (
    <TemplateMain
      g_section="more"
      htmlTitle="Tech Notes"
      linksTitle="More..."
      innerPage={
        <InnerPageTech
          display={(display as TECH_DISPLAY) || ''}
          value={value || ''}
        />
      }
      g_sidebarKey="pageTech"
      g_slideshowKey={SLIDESHOWS.logos}
    />
  )
}
